import React, { useState } from "react";
import "./styles.less";
import classnames from "classnames";
import { useTranslation } from "react-i18next";

export const SolutionDetailContent = (props) => {
  const { t } = useTranslation();
  const { challenges, values } = props;
  const [element, setElement] = useState(1);
  const onMouseLeave = () => {};
  return (
    <div className="solution-detail-content">
      <section className="solution-challenge">
        <div className="inner">
          <div className="top">
            <div className="title">{t("solution.detail.title-challenge")}</div>
          </div>
          <div className="content-warp">
            {challenges?.map((challenge, index) => (
              <div key={index} className="card">
                <div className="card-icon">
                  <i className={challenge.icon}></i>
                  {/* <img src={"//files.authing.co/authing-website/solution-icon-health.svg"} alt="" /> */}
                </div>
                <div className="card-content">
                  <div className="card-title">{challenge.title}</div>
                  <div className="card-text">{challenge.content}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="solution-value">
        <div className="inner">
          <div className="top">
            <div className="title">{t("solution.detail.title-value")}</div>
          </div>
          <div className="content-warp">
            <div className="content-left">
              {values?.map((value, index) => {
                const clstab = classnames({
                  "card-item": true,
                  selected: element === index + 1,
                });
                return (
                  <div
                    key={index}
                    className={clstab}
                    onMouseEnter={() => setElement(index + 1)}
                    onMouseLeave={onMouseLeave}
                  >
                    <div className="item-icon">
                      <i className={value.icon}></i>
                    </div>
                    <div className="item-title">{value.title}</div>
                  </div>
                );
              })}
            </div>
            <div className="content-right">
              {values?.map((value, index) => {
                const cls = classnames({
                  "content-item": true,
                  visible: element === index + 1,
                });
                return (
                  <div key={index} className={cls}>
                    <div className="content-title">{value.title}</div>
                    <div className="content-text">{value.content}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
